import type { ReactNode } from 'react';

import { InfoModal } from '@backrs_ui/common-ui';

import { Box, type SxProps, type Theme, Typography } from '@mui/material';

type WriteDialogProps = Readonly<{
  id: string;
  open: boolean;
  onClose: () => void;
  /** Names the line item the write acts on. */
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer: ReactNode;
}>;

export const WriteDialog = ({
  id,
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
}: WriteDialogProps) => (
  <InfoModal
    open={open}
    onClose={onClose}
    width="sm"
    headerInLineWithIcon
    headerContent={
      <Box sx={headerSx}>
        <Typography id={`${id}-title`} variant="text-lg-semibold">
          {title}
        </Typography>
        {subtitle ? (
          <Typography id={`${id}-subtitle`} variant="text-sm-regular" sx={subtitleSx}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    }
    bodyContent={
      <Box id={id} sx={bodySx} role="group" aria-label={title}>
        {children}
        <Box sx={footerSx}>{footer}</Box>
      </Box>
    }
  />
);

const headerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xxs'],
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
});

const footerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: backrs.spacing['spacing-md'],
});
